<template>
	<div class="newsandinformation">
		<div class="g-s-a-w">
			<img class="news_image" v-lazy="img" />
		</div>
		<div class="introduction container_full po_r m_a">
			<div class="about_us">
				<div>
					<p style="padding-bottom: 20px;">隐私政策</p>
				</div>
				<ul class="active">
					<li class="active">
						<!-- <p class="item">
              <span class="span_css">公司介绍</span>
              <i class="el-icon-arrow-right"></i>
            </p> -->
						<div class="info">
							<div class="info1">
								<span class="info_active" style="color: #FFFFFF;cursor: pointer;">隐私政策</span>
							</div>
							<span class="info_active" @click="tiaoyemain('law')">法律声明</span>
						</div>
					</li>
				</ul>
			</div>
			<div class="com_profile com_profile_active">
				<div class="detail">
					<div style="width: 860px;height:800px;">
						<el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane label="隐私政策" name="first">
								<div class="privacy-con-item" v-if="protocolContent[2]" id="privacy2"></div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Page from "@/components/Service/page.vue";
	import { getProtocol } from "@/utils/protocol.emsWeb.js"
	import { shadowDom } from "@/utils/utils";
	export default {
		name: "newsandinformation",
		data() {
			return {
				img:require('../../../assets/img/Abouts/he_zuo_zi_xun.png'),
				currentPage3: 1,
				activeName: "first",
				details: [],
				gonggao: [],
				pageNo: "1",
				pageNos: "1",
				PageSize: 10,
				PageSizes: 10,
				totals: 0,
				gonggao_title: 0,
				protocolContent: []
			};
		},
		components: {
			Page,
		},
		created() {
			getProtocol().then((res) => {
				this.protocolContent = res;
				this.$nextTick(() => {
					for (let i = 0; i < res.length; i++) {
						shadowDom('privacy' + i, res[i].content)
					}
				});
			});
		},
		methods: {
			handleClick(tab, event) {
				// console.log(tab);
			},
			// 跳页面
			tiaoyemain(main) {
				this.$router.push({
					name: main,
				});
			},
			// 新闻详情
			toNewsAnd(id) {
				this.$router.push({
					path: "details",
					query: {
						id: id,
						staus: "news",
					},
				});
			},
			// 服务公告
			toAnnounceAnd(id) {
				this.$router.push({
					path: "details",
					query: {
						id: id,
						staus: "announce",
					},
				});
			},
		},
	};
</script>
<style scoped lang="scss">
	@import "../../../assets/css/english-css/Abouts/privacy.scss"
</style>